import type { WorkbookTaskRuleOutcome } from '@erp/rpc';

/** What opening a Run's Tasks did, over every Task rule. */
export function runTasksSummary(outcomes: readonly WorkbookTaskRuleOutcome[]) {
  return outcomes.reduce(
    (total, outcome) => ({
      opened: total.opened + outcome.opened,
      existing: total.existing + outcome.existing,
      truncated: total.truncated || outcome.truncated,
    }),
    { opened: 0, existing: 0, truncated: false },
  );
}
